import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import LogoutTimer from "./LogoutTimer";
import RefreshInternalToken from "./RefreshInternalToken";

const ProtectedRoute = ({ children }) => {
    const temp = JSON.parse(localStorage.getItem("token_rare"));

    if (!temp || temp === null || undefined) {
        return <Navigate to="/signin" />;
    }

    return (
        <>
            {children}
            <LogoutTimer />
            <RefreshInternalToken />
        </>
    );
};

export default ProtectedRoute
